// @flow

import React from 'react';
import type {CryptocurrencyProtocol} from '@tectonics/commons/cryptocurrency/protocol/cryptocurrency-protocol-type';
import Bep20Icon from './bep20-icon';

export const bep20: CryptocurrencyProtocol = {
  code: 'BEP20',
  icon: <Bep20Icon alt="bep20 icon"/>,
  abbreviation: 'BEP-20',
  name: 'BNB Smart Chain (BEP-20)',
};
